export const SOCIAL_AND_ADS_VISUALS_CATEGORY = "Social & Ads Visuals";
export const PRODUCT_PACK_SHOTS_CATEGORY = "Product Pack Shots";
export const OUTDOOR_PHOTO_SHOOT_CATEGORY = "Outdoor Photoshoots";
export const STUDIO_PHOTO_SHOOT_CATEGORY = "Studio Photoshoots";
export const MOODBOARDS_CATEGORY = "Moodboards";
export const BRAND_ASSETS_CATEGORY = "Brand Assets";
export const PORTRAITS_CATEGORY = "Portraits";
export const STOCK_IMAGES_CATEGORY = "Stock Images";

export const QUICK_ACTIONS_CATEGORIES = [
  SOCIAL_AND_ADS_VISUALS_CATEGORY,
  PRODUCT_PACK_SHOTS_CATEGORY,
  OUTDOOR_PHOTO_SHOOT_CATEGORY,
  STUDIO_PHOTO_SHOOT_CATEGORY,
  MOODBOARDS_CATEGORY,
  BRAND_ASSETS_CATEGORY,
  PORTRAITS_CATEGORY,
  STOCK_IMAGES_CATEGORY,
] as const;
